import { render, staticRenderFns } from "./vip-choose-free.vue?vue&type=template&id=56478366&scoped=true&"
import script from "./vip-choose-free.vue?vue&type=script&lang=js&"
export * from "./vip-choose-free.vue?vue&type=script&lang=js&"
import style0 from "./vip-choose-free.vue?vue&type=style&index=0&id=56478366&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56478366",
  null
  
)

export default component.exports